/**
 * Given an array of options and a current value, return the derived value.
 * If the current value is not among the options and there is exactly one
 * option, auto-select it. Otherwise return the current value unchanged.
 *
 * Options may be strings or `{ value, label }` objects.
 *
 * @param {Array<string | { value: string, label: string }>} options
 * @param {string} currentValue
 * @returns {string}
 */
export function deriveSelectValue(options, currentValue) {
	if (options.length === 1) {
		const single = options[0];
		if (single === undefined) { return currentValue; }
		const val = typeof single === 'string' ? single : single.value;
		if (val !== currentValue) { return val; }
	}
	return currentValue;
}
